<template>
  <router-view v-if="isRouterAlive"></router-view>
</template>

<script>
export default {
  name: 'app',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },

  methods: {
    // 解决route到本身页面刷新问题
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
// CoreUI Icons Set
// @import "@coreui/icons/css/coreui-icons.min.css";

/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "font-awesome/scss/font-awesome.scss";

/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "simple-line-icons/scss/simple-line-icons.scss";

/* Import Flag Icons Set */
// @import "flag-icon-css/css/flag-icon.min.css";

/* Import Bootstrap Vue Styles */
@import "bootstrap-vue/dist/bootstrap-vue.css";

// Import Main styles for this application
@import "assets/scss/style";
</style>



// WEBPACK FOOTER //
// src/App.vue